import {internalLinkToHref} from 'utils';
import {sanityFetch} from 'utils/sanity.fetch';
import type {LinkReferencesQueryResult} from 'utils/sanity.queries';
import {LINK_REFERENCES_QUERY} from 'utils/sanity.queries';

import type {CallToActionSchema} from 'components/call-to-action/schema';

import {CallToActionRender} from './render';

interface Props {
	callToAction: CallToActionSchema;
}

export const CallToActionServer = async ({callToAction}: Props) => {
	if (!callToAction.reference) {
		return null;
	}

	const reference = await sanityFetch<LinkReferencesQueryResult>({
		query: LINK_REFERENCES_QUERY,
		params: {id: callToAction.reference._ref},
	});

	return (
		<CallToActionRender
			href={internalLinkToHref(reference?._type, reference?.slug?.current)}
			targetBlank={callToAction.targetBlank}
			text={callToAction.text ?? ''}
			color={callToAction.color ?? 'primary'}
		/>
	);
};
